module.exports = __webpack_public_path__ + "static/media/wicc.eea25ca9.svg";